/** @jsx jsx */
/** @jsxRuntime classic */
import React from "react";
import { jsx } from "@emotion/core";
import { Image } from "@certa/blocks";
import type { FilePreviewProps } from "../../types/FilePreviewerTypes";
import { useIntl } from "react-intl";

const ImagePreviewer = ({ url, ...restImageProps }: FilePreviewProps) => {
  const intl = useIntl();
  return (
    <Image
      {...restImageProps}
      width="100%"
      height="450px"
      alt={intl.formatMessage({
        id: "filePreviewer.previewNotAvailable"
      })}
      src={url}
    />
  );
};

export { ImagePreviewer };

ImagePreviewer.mimeTypes = ["image/jpeg", "image/png", "image/jpg"];
